// removed by extract-text-webpack-plugin
module.exports = {"fs-wrap":"fs-wrap___126YU space-top-12___3DU92","fs-title":"fs-title___QYoto h1___3_4RF space-bottom-3___1rDcV","fs-copy":"fs-copy___3JRbm h3___5u0xZ space-bottom-3___1rDcV","fs-disclaimer":"fs-disclaimer___a5uOE h4___kHWTn space-bottom-10___3yYX1","fs-subtitle":"fs-subtitle___EcEGy h2___hzLuT space-top-10___1FChW space-bottom-3___1rDcV","fs-ul":"fs-ul___6lR-7","fs-li":"fs-li___ftZVP h3___5u0xZ space-bottom-3___1rDcV","fs-cta":"fs-cta___QY6v0 h3___5u0xZ","fs-stat":"fs-stat___28oRp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FamilyFactSheet/FamilyFactSheet.css
// module id = 886
// module chunks = 0